export var CircularStepLoaderSteps;
(function (CircularStepLoaderSteps) {
    CircularStepLoaderSteps[CircularStepLoaderSteps["ONE"] = 1] = "ONE";
    CircularStepLoaderSteps[CircularStepLoaderSteps["TWO"] = 2] = "TWO";
    CircularStepLoaderSteps[CircularStepLoaderSteps["THREE"] = 3] = "THREE";
})(CircularStepLoaderSteps || (CircularStepLoaderSteps = {}));
export var CircularLoaderSize;
(function (CircularLoaderSize) {
    CircularLoaderSize["SMALL"] = "SMALL";
    CircularLoaderSize["NORMAL"] = "NORMAL";
})(CircularLoaderSize || (CircularLoaderSize = {}));
export const svgPaths = [
    'M54.5139 15.0238C60.9095 15.2789 67.1371 17.1453 72.6187 20.4499C78.1004 23.7546 82.6585 28.3903 85.8701 33.9269C89.0816 39.4636 90.8426 45.7218 90.9897 52.1208C91.1367 58.5198 89.665 64.8522 86.7111 70.5306L78.2832 66.1463C80.4987 61.8876 81.6024 57.1382 81.4922 52.339C81.3819 47.5397 80.0611 42.8461 77.6525 38.6936C75.2438 34.5411 71.8252 31.0643 67.714 28.5859C63.6028 26.1074 58.9321 24.7076 54.1354 24.5163L54.5139 15.0238Z',
    'M85.125 73.2925C81.7063 78.7037 76.9762 83.1637 71.3735 86.2587C65.7708 89.3536 59.4771 90.9831 53.0764 90.9961C46.6757 91.0091 40.3755 89.4051 34.7603 86.3329C29.1451 83.2608 24.3969 78.82 20.9562 73.4227L28.967 68.3161C31.5475 72.364 35.1086 75.6946 39.32 77.9988C43.5315 80.3029 48.2566 81.5059 53.0572 81.4961C57.8577 81.4864 62.5779 80.2642 66.78 77.943C70.982 75.6218 74.5296 72.2768 77.0936 68.2184L85.125 73.2925Z',
    'M19.3591 70.668C16.3822 65.0018 14.8848 58.6753 15.0058 52.2758C15.1269 45.8762 16.8625 39.611 20.0516 34.0613C23.2407 28.5117 27.7799 23.8575 33.2481 20.5307C38.7163 17.2038 44.9362 15.3122 51.3307 15.0312L51.7478 24.522C46.9519 24.7328 42.287 26.1515 38.1858 28.6466C34.0847 31.1418 30.6803 34.6324 28.2884 38.7946C25.8966 42.9568 24.5949 47.6558 24.5041 52.4555C24.4133 57.2551 25.5364 61.9999 27.7691 66.2497L19.3591 70.668Z',
];
export const loaderDimensions = {
    [CircularLoaderSize.SMALL]: {
        height: '30',
        width: '30',
    },
    [CircularLoaderSize.NORMAL]: {
        height: '76',
        width: '76',
    },
};
export const getLoaderSvgSize = (loaderSize) => {
    if (loaderSize) {
        return {
            height: loaderDimensions[loaderSize].height,
            width: loaderDimensions[loaderSize].width,
        };
    }
    return {
        height: loaderDimensions[CircularLoaderSize.NORMAL].height,
        width: loaderDimensions[CircularLoaderSize.NORMAL].width,
    };
};
//# sourceMappingURL=circular-step-loader.constants.js.map